import { ReactNode } from 'react';
import { css, cx } from '@linaria/atomic';
import { Text } from '../../../text/text.component';

const textBubbleTextStyle1 = css`
  word-break: break-word;
`;

type TextBubbleProps = {
  text: ReactNode;
  subText?: ReactNode;
  variant?: 'deleted' | 'text' | 'call';
};
export const TextBubble = ({ text, subText, variant }: TextBubbleProps) => {
  return (
    <div className='bubble-content'>
      {typeof text === 'string' ? (
        <Text
          size='medium'
          className={cx(textBubbleTextStyle1, 'bubble-text')}
          color={variant === 'deleted' ? 'subdued' : 'default'}
        >
          {text}
        </Text>
      ) : (
        text
      )}
      {subText &&
        (typeof subText === 'string' ? (
          <Text size='small' className='bubble-text'>
            {subText}
          </Text>
        ) : (
          subText
        ))}
    </div>
  );
};
